export * from './firebase.app.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /Users/briznad/Documents/WebDev/personal/cartmigo/cartmigo-dev/~/angularfire2/app/index.js
// module id = ../../../../angularfire2/app/index.js
// module chunks = 3